import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <style>
        {`
          .footer {
            background-color: #1d1d1d;
            color: #ecf0f1;
            text-align: center;
            position: bottom;
          }
        `}
      </style>

      <footer className="footer" id="footer-item">
        <p>
          &copy; 2024 Studio Romeo. Tutti i diritti riservati.
          <Link
            to="/privacy"
            style={{ color: "#ecf0f1", marginLeft: "10px" }}
          >
            Privacy
          </Link>
        </p>
      </footer>
    </>
  );
};

export default Footer;
